import { useCallback, useEffect, useState } from 'react'
import Icon from '@mdi/react'
import { mdiMenu, mdiClose } from '@mdi/js'

import theme from 'theme_'
import { StyledMobileMenuBtn } from './styles'
import MobileMenuInner from './MobileMenuInner'

function MobileMenu() {
  const [isOpen, setIsOpen] = useState(false)
  let isDesktopQuery = window.matchMedia(theme.devices.desktop)

  const toggleIsOpen = () => setIsOpen(!isOpen)

  const resizeEventListener = useCallback(
    (e: MediaQueryListEvent) => {
      if (e.matches && isOpen) {
        setIsOpen(false)
      }
    },
    [isOpen]
  )

  useEffect(() => {
    isDesktopQuery.addEventListener('change', resizeEventListener)
    return () => {
      isDesktopQuery.removeEventListener('change', resizeEventListener)
    }
  })

  return (
    <>
      <StyledMobileMenuBtn onClick={toggleIsOpen}>
        <Icon path={isOpen ? mdiClose : mdiMenu} size={1} color="#fff" />
      </StyledMobileMenuBtn>
      {isOpen && <MobileMenuInner handleClose={() => setIsOpen(false)} />}
    </>
  )
}

export default MobileMenu
